import { useNavigate, useSearchParams } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useBodyTypeFormHandling } from "./components/BodyTypeStateHandle";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const InsurerBodyTypeForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    
    const bodyTypeId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
        ? "edit" : "add";
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [motorBodyTypeOptions, setMotorBodyTypeOptions] = useState([]);

    useEffect(() => {
        if (pageMode === "add" || !bodyTypeId) {
            return;
        }
        //Fetch data by Pincode Id
        const fetchBodyTypeById = async (bodyTypeId) => {
            try {
            const response = await fetchDataById(`/reference/insurer/body-type/${bodyTypeId}`);

            const responseData = response?.data?.bodyType;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    code: responseData?.code || "",
                    mBodyType: { label :responseData?.motorBodyTypeName, value: responseData?.mBodyTypeId },
                    gInsurer: { label: responseData?.generalInsurerName, value: responseData?.gInsurerId },
                    isActive: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    codeStatus: responseData?.code ? "success" : "unchecked",
                    mBodyTypeStatus: responseData?.mBodyTypeId ? "success" : "unchecked",
                    gInsurerStatus: responseData?.gInsurerId ? "success" : "unchecked",
                };

                setFormData(mapped);  
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar("Error fetching Insurer Body Type Data", "error");
            }
        };
        fetchBodyTypeById(bodyTypeId);
    }, [pageMode]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, [pageMode]);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            insurerResponse,
            bodyTypeResponse,
            ] = await Promise.all([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/motor/body-type?dropdown=true&isActive=true`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedBodyTypes = bodyTypeResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];
            
            setGeneralInsurerOptions(formattedInsurers);
            setMotorBodyTypeOptions(formattedBodyTypes);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching Insurer Body Type Dropdowns", "error");
        } finally {
            setCircleLoading(false);
        }
    };

    const handleSubmitBodyType = async () => {
        const payload = {
            gInsurerId: formData?.gInsurer?.value,
            mBodyTypeId: formData?.mBodyType?.value,
            name: formData?.name,
            code: formData?.code,
            isActive: formData?.isActive,
        };
        //Update
        if(bodyTypeId){
            try {
                const response = await putData(`/reference/insurer/body-type/${bodyTypeId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/insurer-master/body-type');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Error Updating Body Type","error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/insurer/body-type', payload);
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/insurer-master/body-type');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error posting data:', error);
                //catch error message
                showSnackbar(error?.response?.data?.message || "Network Error", "error");
            }
        }
    };

    const { formData, setFormData, handleChange, checkAllFields } = useBodyTypeFormHandling(); 
    

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/insurer-master/body-type")}>
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Body Type Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Body Types Details to Insurer.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Insurer
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Motor Body Type
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="mBodyType"
                        value={formData.mBodyType}
                        onChange={handleChange}
                        options={motorBodyTypeOptions}
                        success={formData.mBodyTypeStatus === "success"}
                        error={formData.mBodyTypeStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Body Type Name
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                             <FormControl error>
                                <FormHelperText>
                                Body Type Name should be a minimum 1 character & maximum 100
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Body Type Code
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                             <FormControl error>
                                <FormHelperText>
                                Body Type Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Active
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/insurer-master/body-type")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitBodyType}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
        </Card>        
    </DashboardLayout>
  )
}

export default InsurerBodyTypeForm